<template>
<div class="chapter">
<div class="inner_page">
<p class="p6"><span class="t8">By</span> X<span class="t9">AVIER</span> M<span class="t9">AYNE</span></p>
<p class="p0"><span class="t8">The Accidental Cupid</span></p>
<p class="p0"><span class="t8">Husband Material</span></p>
<p class="p0"><span class="t10">A B</span><span class="t11">RANDT</span> <span class="t11">AND</span> <span class="t10">D</span><span class="t11">ONNELLY</span> <span class="t10">C</span><span class="t11">APER</span></p>
<p class="p0"><span class="t8">Frat House Troopers</span></p>
<p class="p0"><span class="t8">Wrestling Demons</span></p>
<p class="p0"><span class="t8">A Wedding to Die For</span></p>
<p class="p0"><span class="t8">Spring Break at the Villa Hermes</span></p>
<p class="p7"><span class="t8">Published by</span> D<span class="t9">REAMSPINNER</span> P<span class="t9">RESS</span></p>
<p class="p0"><span class="t8">http://www.dreamspinnerpress.com</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?fd8c4f76